import { useEffect } from "react";
import useScrollToTop from "../../hooks/use-scroll-to-top";
import { FaWhatsapp, FaFacebook, FaInstagram,FaLinkedin,FaYoutube } from "react-icons/fa";
import ChatbotPopup from "../Chatbot/ChatbotPopup"; // Adjust path as needed


const BackToTop = () => {
  const { stick, onClickHandler } = useScrollToTop();

  useEffect(() => {
    const progressPath = document.querySelector(".progress-wrap path");

    if (!progressPath) return; // ✅ Prevents errors if the element is not found

    const pathLength = progressPath.getTotalLength();
    progressPath.style.transition = "none";
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = "stroke-dashoffset 10ms linear";

    const updateProgress = () => {
      const scroll = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const height = docHeight - winHeight;

      if (height > 0) {
        const progress = pathLength - (scroll * pathLength) / height;
        progressPath.style.strokeDashoffset = progress;
      }
    };

    updateProgress();
    window.addEventListener("scroll", updateProgress);
    return () => window.removeEventListener("scroll", updateProgress);
  }, []);
  return (
    <div
      style={{
        position: "fixed",
        bottom: "90px",
        right: "20px",
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      role="button"
      onClick={onClickHandler}
      tabIndex={-1}
    >
      {/* Social Media Icons */}
      <div style={{ display: "flex", gap: "10px", flexDirection: "column", marginBottom: "10px" }}>
        {/* WhatsApp */}
        <div
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            background: "#25D366",
            position:'relative',
            top:'-10px'
          }}
        >
          <a href="https://api.whatsapp.com/send/?phone=%2B919574100028&text=Hello+%21+I+await+for+your+response.+Thank+you&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp size={32} color="white" />
          </a>
        </div>
  
        {/* Facebook */}
        <div
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            background: "#1877F2",
             position:'relative',
            top:'-10px'
          }}
        >
          <a href="https://www.facebook.com/lumetiqluxurylift?mibextid=LQQJ4d&_rdr" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={32} color="white" />
          </a>
        </div>
  
        {/* Instagram */}
        <div
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
             position:'relative',
            top:'-10px',
            background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
          }}
        >
          <a href="https://www.instagram.com/lumetiq_elevators/" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={32} color="white" />
          </a>
        </div>
  
        {/* LinkedIn */}
        <div
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            background: "#0077B5",
            position:'relative',
            top:'-10px',
          }}
        >
          <a href="https://www.linkedin.com/in/umesh-patel-28230b1a5/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin size={32} color="white" />
          </a>
        </div>
  
        {/* YouTube */}
        <div
          style={{
            width: "50px",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            background: "#FF0000",
            position:'relative',
            top:'-10px',
          }}
        >
          <a href="https://www.youtube.com/@lumetiq_group" target="_blank" rel="noopener noreferrer">
            <FaYoutube size={32} color="white" />
          </a>
        </div>
      </div>
  
      {/* Progress Circle */}
      <div
        className={`progress-wrap ${stick && "active-progress"}`}
        role="button"
        onClick={onClickHandler}
        onKeyUp={(e) => e}
        tabIndex={-1}
        style={{ position: 'absolute', top: '291px', left: '6px' }}
      >
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
  
      {/* Chatbot Popup Component */}
      <ChatbotPopup />
    </div>
  );
  
 
};

export default BackToTop;